import React from "react";
import { observer } from "mobx-react";

// 0 0px 8px 0 rgb(145, 199, 75), 0 6px 20px 0 rgba(0, 0, 0, 0.19)

function Box({ number, label, complete, highlight }) {
  return (
    <div
      style={{
        flexGrow: 1,
        display: "flex",
        fontSize: 14,
        maxWidth: "31%",
        justifyContent: "space-between",
        backgroundImage: complete
          ? "linear-gradient(to right, #8bc53e 0%, rgb(175, 210, 130) 100%)"
          : "linear-gradient(to right, rgb(253, 74, 74) 0%, rgb(249, 135, 135) 100%)",
        color: "white",
        fontWeight: "bold",
        alignItems: "center",
        borderRadius: 5,
        boxShadow: highlight ? "0 0px 8px 0 rgb(145, 199, 75)" : "",
        textTransform: "uppercase"
      }}
    >
      <div
        style={{
          padding: 10,
          color: "white",
          fontWeight: "bold",
          paddingLeft: 15
        }}
      >
        {number}
      </div>
      <div style={{ padding: 10 }}>{label}</div>
      <div
        style={{
          width: 39,
          padding: 10,
          paddingRight: 15
        }}
        className={"hidden-sm hidden-xs"}
      >
        {complete ? <i className="fa fa-check-square" /> : <i className="fa fa-square" />}
      </div>
    </div>
  );
}
function RegistrationFlow({ sampleStore, branchSelected }) {
  const hasSamples = sampleStore.samples.length > 0;
  const validSamples = sampleStore.samplesAreValid();
  return (
    <div className={"hidden-xs"} style={{ maxWidth: "calc(95vw - 20px)" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          maxWidth: "900px",
          margin: "0 auto",
          marginBottom: 20
        }}
      >
        <Box
          number={1}
          label={"Select Branch"}
          complete={branchSelected}
          highlight={!branchSelected}
        />
        <Box
          number={2}
          label={"Add Samples"}
          complete={hasSamples}
          highlight={branchSelected && !hasSamples}
        />
        <Box
          number={3}
          label={"Add Sample Information"}
          complete={hasSamples && validSamples}
          highlight={branchSelected && hasSamples && !validSamples}
        />
      </div>
    </div>
  );
}

export default observer(RegistrationFlow);
